import React from 'react'
import PropTypes from 'prop-types'
import { StyledSuccessFeedbackWrapper, StyledTextWrapper } from './styles'
import SuccessImage from '../../../images/caf/success.svg'
import { Text } from '../../atoms/text'
import { Button } from '../../atoms/button'
import { useTranslation } from '../../../context/translationProvider'

export const CAFSuccessStep = ({ onClose }) => {
  const { translate } = useTranslation()

  return (
    <StyledSuccessFeedbackWrapper>
      <img alt="success" src={SuccessImage} />
      <StyledTextWrapper>
        <Text bold extraBig noMargin>
          {translate('caf.onboarding.success.title')}
        </Text>
        <Text noMargin>{translate('caf.onboarding.success.description')}</Text>
        <Button onClick={onClose}>
          {translate('caf.onboarding.success.closeButton')}
        </Button>
      </StyledTextWrapper>
    </StyledSuccessFeedbackWrapper>
  )
}

CAFSuccessStep.defaultProps = {
  onClose: null,
}

CAFSuccessStep.propTypes = {
  onClose: PropTypes.func,
}
